import React from "react";
import Link from "helpers/link";
import getContainerSizeClass from "@root/helpers/get-container-size-class";

const ButtonsList = ({ data }) => {
    const buttons = data?.buttons || [];
    const gap = data?.gap;
    const justifyContent = data?.justifyContent;
    const classes = getContainerSizeClass(data?.moduleSettings);

    const gapValue = typeof gap === "number" ? `${gap}px` : gap || "12px";
    const justifyContentValue = justifyContent || "flex-start";

    const getButtonStyle = (style) => {
        const buttonStyles = {
            primary: "buttons-list__button--primary",
            secondary: "buttons-list__button--secondary",
            tertiary: "buttons-list__button--tertiary",
            link: "buttons-list__button--link",
        }
        return buttonStyles[style] || buttonStyles.primary;
    }

    if (!buttons.length) return null;

    return (
        <div
            className={`buttons-list ${classes.join(" ")}`}
            style={{
                "--buttons-list-gap": gapValue,
                "--buttons-list-justify-content": justifyContentValue,
            }}
        >
            {buttons.map((button) => {
                if (!button?.title || !button?.url) return null;

                return (
                    <Link
                        key={button?._key || button?.url}
                        className={`buttons-list__button ${getButtonStyle(button?.style)}`}
                        to={button?.url}
                    >
                        {button?.title}
                    </Link>
                );
            })}
        </div>
    );
};

export default ButtonsList;